import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize, Subject } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent {
  private readonly authService = inject(AuthService);


  forgotForm: FormGroup;

  loading$: Subject<boolean | null> = new Subject();

  sent: boolean = false;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.forgotForm = formBuilder.group({
      email: [null, [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    this.loading$.next(true);

    this.authService.sendResetPasswordLink(this.forgotForm.value.email).pipe(
      finalize(() => {
        this.loading$.next(false);
      })
    ).subscribe({
      next: () => {
        this.showSentState();
      },
      error: () => {
        this.showSentState();
      }
    });
  }

  private showSentState(): void {
    this.sent = true;
  }

}
